import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { isPwa } from '../../utils/isPwa';

interface FixedBottomBarProps {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}

const FixedBottomBar: React.FC<FixedBottomBarProps> = ({ children, sx }) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: isPwa() ? 'calc(56px + env(safe-area-inset-bottom))' : 0,
        left: 0,
        right: 0,
        py: { xs: 1.5, md: 2 },
        px: 2,
        pb: isPwa() ? 1.5 : 'calc(12px + env(safe-area-inset-bottom))',
        display: 'flex',
        justifyContent: 'center',
        gap: 1.5,
        backgroundColor: 'rgba(18, 18, 18, 0.85)',
        backdropFilter: 'blur(12px)',
        borderTop: '1px solid rgba(255, 255, 255, 0.08)',
        zIndex: 1100,
        ...sx as any,
      }}
    >
      {children}
    </Box>
  );
};

export default FixedBottomBar;
